<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'

import ComponentAveragesTable from '@/components/ComponentAveragesTable'
import ComponentAveragesChart from '@/helpers/ComponentAveragesChart'
import SelfReflection from '@/components/SelfReflection'
import DashboardHeading from '@/components/DashboardHeading'
import DashboardText from '@/components/DashboardText'
import ComponentAveragesChartContainer from '@/components/ComponentAveragesChartContainer'

import { teacherDashboardHelper } from '@/helpers/teacherDashboardHelper'
import { onboardingHelper } from '@/helpers/onboardingHelper'

import EventBus from '@/event-bus'

import store from '@/store'

const components = ['1a', '1e', '2a', '2d', '3b', '3c', '3d', '4e']

@Component({
    components: {
        ComponentAveragesTable,
        ComponentAveragesChart,
        SelfReflection,
        DashboardHeading,
        DashboardText,
        ComponentAveragesChartContainer
    },
    computed: {
        ...mapGetters({
            userRole: "getUserRole",
            teacherInfo: "teacher/getTeacherInfo",
            componentsInfo: "teacher/getComponents",
            fiscalYear: 'getFiscalYear'
        })
    }    
})

export default class Dashboard extends Vue {

    dashboardType = 'teacher'
    steps = teacherDashboardHelper().teacherSteps
    created() {
      store.commit('currentPage', 'teacher-dashboard')
    }
    mounted() {
        EventBus.$on('start intro', () => {
            this.startIntro()
        })
        
        this.$nextTick(() => {
            if (localStorage.getItem('doneTeacherDashboardOnboarding')) {
                return
            } else {
                this.startIntro();
            }
        })
    }

    get currentYearHasObservations () {
        return this.componentsInfo[this.fiscalYear].motpScore !== null
    }
    
    startIntro() {
        onboardingHelper().startIntro(
            introJs(), this, 'doneTeacherDashboardOnboarding'
        )
    }
    
}

</script>

<template>
    <div>
        <div class="welcome-note">
            <p>
                <strong>Hi!</strong> Welcome to your school's observation dashboard!
            </p>
            <ul>
                <li v-if="!currentYearHasObservations">
                    <div>
                        <img src="@/assets/images/announcement.png" alt="announcement">
                    </div>
                    <p>We don't have observation data yet for this school year yet, but you can review your prior year data below.</p>
                </li>
                <li>
                    <div>
                        <img src="@/assets/images/assignment.png" alt="assignment">
                    </div>
                    <p>You can also find the new Fall Form <router-link :to="{path: 'goalSetting/teacher'}">here</router-link> which prompts you to reflect on how the year is going thus far. This form can be helpful in having more meaningful followup conversations with your administrators and/or coaches.</p>
                </li>
            </ul>
        </div>
        <DashboardHeading
            :userRole="userRole"
            :dashboardType="dashboardType">
        </DashboardHeading>

        <ComponentAveragesTable
            id="comps-table"
            :teacherInfo="teacherInfo"
            :userRole="userRole"
            :componentsInfo="componentsInfo">   
        </ComponentAveragesTable>

        <DashboardText/>

        <SelfReflection 
          :userRole="userRole">
        </SelfReflection>

        <div class="chart-container">
            <ComponentAveragesChartContainer
                :componentsInfo="componentsInfo">
            </ComponentAveragesChartContainer>
        </div>

    </div>
</template>

<style lang="scss" scoped>
    div {
        .self-reflection {
            max-width: 78%;
            margin: 50px auto;
        }
    }
    .welcome-note {
        font-family: Arial;
        color: #333333;
        padding: 1em;
        border: 2px solid #c4c4c4;
        border-radius: 8px;
        p {
            font-family: Arial;
        }
        > p {
          font-size: 1.25em;  
        }
        ul {
            padding: 0;
        }
        li {
            display: flex;
            align-items: center;
            div {
                display: flex;
                justify-content: end;
                margin-right: 20px;
            }
            p {
                font-size: 1.125em;
                font-weight: 400;
                margin: 0;
            }
        }
        li:first-child {
            margin-bottom: 1em;
        }
    }
</style>